// import React from "react";
// import "./dashboard.css";

// const Dashboard = () => {
//   return (
//     <div>Dashboard</div>
//   )
// }

// export default Dashboard

// import React from "react";
// import { useNavigate } from "react-router-dom";
// import "./dashboard.css";

// const Dashboard = () => {
//   const navigate = useNavigate();

//   return (
//     <div className="admin-layout">
//       {/* SIDEBAR */}
//       <aside className="sidebar">
//         {/* <div
//           className="logo"
//           onClick={() => navigate("/admin/dashboard")}
//         >
//           KARN Admin
//         </div> */}

//         <ul className="menu">
//           {/* <li
//             className="active"
//             onClick={() => navigate("/admin/dashboard")}
//           >
//             Dashboard
//           </li> */}

//           <li onClick={() => navigate("/contact-us-details")}>
//             Contact Us Enquiries
//           </li>

//           <li onClick={() => navigate("/seo-enquiry-details")}>
//             SEO / Website Enquiries
//           </li>
//         </ul>
//       </aside>

//       {/* MAIN CONTENT */}
//       <main className="main-content">
//         <h1 className="page-title">Welcome to KARN Admin Panel</h1>

//         <div className="dashboard-cards">
//           <div
//             className="card"
//             onClick={() => navigate("/contact-us-details")}
//           >
//             <h3>Contact Us</h3>
//             <p>View all contact form submissions</p>
//           </div>

//           <div
//             className="card"
//             onClick={() => navigate("/seo-enquiry-details")}
//           >
//             <h3>SEO Enquiries</h3>
//             <p>View SEO & website enquiries</p>
//           </div>
//         </div>
//       </main>
//     </div>
//   );
// };

// export default Dashboard;

// import React from "react";
// import "./dashboard.css";
// import AdminLayout from "../../layouts";
// import { useNavigate } from "react-router-dom";
// import { FiMail, FiSearch } from "react-icons/fi";

// const Dashboard = () => {
//   const navigate = useNavigate();
//   return (
//     <AdminLayout>
//       <h1>Welcome to KARN Admin Panel</h1>
//       <div className="dashboard-cards">
//            <div
//             className="card"
//             onClick={() => navigate("/contact-us-details")}
//           >
//             <h3>Contact Us</h3>
//             <p>View all contact form submissions</p>
//           </div>

//           <div
//             className="card"
//             onClick={() => navigate("/seo-enquiry-details")}
//           >
//             <h3>SEO Enquiries</h3>
//             <p>View SEO & website enquiries</p>
//           </div>
//           </div>
//     </AdminLayout>
//   );
// };

// export default Dashboard;

import React from "react";
import { useNavigate } from "react-router-dom";
import { FiMail, FiSearch } from "react-icons/fi"; // Importing icons
import "./dashboard.css";
import AdminLayout from "../../layouts";

const Dashboard = () => {
  const navigate = useNavigate();

  return (
    <AdminLayout>
      <div className="dashboard-content">
        <h2 className="page-title text-center">Welcome to KARN Admin Panel</h2>
        
        <div className="dashboard-cards">
          {/* Contact Us Card */}
          <div
            className="card"
            onClick={() => navigate("/contact-us-details")}
          >
            <div className="card-icon-wrapper">
              <FiMail size={30} className="card-icon" />
            </div>
            <h3>Contact Us</h3>
            <p>View all contact form submissions</p>
          </div>

          {/* SEO Enquiries Card */}
          <div
            className="card"
            onClick={() => navigate("/seo-enquiry-details")}
          >
            <div className="card-icon-wrapper">
              <FiSearch size={30} className="card-icon" />
            </div>
            <h3>SEO Enquiries</h3>
            <p>View SEO & website enquiries</p>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default Dashboard;


